import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * A hook that wraps React Router's navigate with View Transitions API support.
 * Provides smooth page transitions when navigating between routes.
 * Falls back to standard navigation for unsupported browsers.
 * 
 * Sets a sessionStorage flag for the landing bounce animation on the chat card.
 */
export function useAnimatedNavigate() {
  const navigate = useNavigate();
  
  return useCallback((to: string, options?: { replace?: boolean }) => {
    // Set flag for landing bounce animation
    sessionStorage.setItem('chat_card_landing_bounce', '1');
    
    // Check for View Transitions API support
    if ('startViewTransition' in document) {
      // Use requestAnimationFrame to ensure sessionStorage is committed before transition
      requestAnimationFrame(() => {
        (document as any).startViewTransition(() => {
          navigate(to, options);
        });
      });
    } else {
      // Fallback for unsupported browsers
      navigate(to, options);
    }
  }, [navigate]);
}
